// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'user-check';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M.563 12.938a5.065 5.065 0 0 1 7.05-4.656M2.531 3.656a3.094 3.094 0 1 0 6.188 0 3.094 3.094 0 0 0-6.188 0zm14.907 9.282a4.5 4.5 0 1 1-4.5-4.5' />
    <path d='m17.438 9.562-4.103 4.102a.561.561 0 0 1-.795 0l-1.29-1.289' />
  </g>
);

export const viewBox = '0 0 18 18';
